/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RecordHashedBackupTagRequest} from '@cash-web/protos/squareup/cash/janus/api/HashedBackupTagsProto.pb'
import {RecordHashedBackupTagResponse} from '@cash-web/protos/squareup/cash/janus/api/HashedBackupTagsProto.pb'


export const recordHashedBackupTag = (request:RecordHashedBackupTagRequest, options?: CashRequestOptions) => post<RecordHashedBackupTagRequest, RecordHashedBackupTagResponse>("/2.0/cash/record-hashed-backup-tag", request, {...options, rejectOnError: true })